import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CreateEditProfile } from '../../../../alerts/alertSetting/createEditProfile'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { getAlertProfile } from '../store/thunk'

export const CreateAlertProfile = ({ setActiveTypeAlert }) => {
  const dispatch = useDispatch()

  const { width, height } = useViewport()

  const [isShow, setIsShow] = useState(false)

  const handleClick = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const onSave = (params) => {
    dispatch(getAlertProfile())
      .unwrap()
      .then((res) => {
        const newProfileCreated = res?.find(
          (item) =>
            item.profileAlertsName.trim() === params.profileAlertsName.trim(),
        )
        if (newProfileCreated) {
          setActiveTypeAlert({
            label: newProfileCreated.profileAlertsName,
            value: newProfileCreated.profileAlertId,
          })
        }

        handleClose()
      })
  }

  return (
    <>
      <Element
        elementName="p"
        onClick={handleClick}
        className="cursorPointer"
        style={{ color: '#2C73E8' }}
      >
        <Translate value="library.savePortfolio.CREATE_ALERT_PROFILE" />
      </Element>

      <PopupAction
        isShow={isShow}
        title="alertSetting.NEW_ALERT_PROFILE"
        handleClose={handleClose}
        appendStyle={{
          width: 0.95 * width,
          maxWidth: 1000,
          padding: '20px 20px 8px 20px',
          backgroundColor: '#F3F3F3',
          borderRadius: '4px',
        }}
      >
        <Element
          style={{ height: 0.8 * height, maxHeight: 884, margin: '0 -8px' }}
        >
          <CreateEditProfile
            createMode={true}
            onCancel={handleClose}
            onSave={onSave}
          />
        </Element>
      </PopupAction>
    </>
  )
}
